import { all, fork } from "redux-saga/effects";
import { watchNotification } from "./notificationList";
import { watchMessageCountListSaga } from "./notificationUnreadCount";
import { watchParentNotification } from "./parentNotification"

export default function* rootNotificationSagas() {
  yield all([fork(watchNotification), fork(watchMessageCountListSaga),fork(watchParentNotification)]);
}
